import { memo, type ReactNode } from 'react';
import { classNames } from '~/utils/classNames';

interface SettingBlockProps {
  id: string;
  title: string;
  description: ReactNode;
  action: ReactNode;
  wrapperClassName?: string;
  className?: string;
}

export const SettingBlock = memo((props: SettingBlockProps) => {
  const { id, title, description, action, wrapperClassName, className } = props;
  return (
    <div className={classNames('flex justify-between gap-4 items-center', wrapperClassName)}>
      <div className={classNames('flex flex-col gap-1', className)}>
        <label className="font-semibold text-sm text-bolt-ds-textPrimary" htmlFor={id}>
          {title}
        </label>
        <div className="text-sm text-bolt-ds-textSecondary">{description}</div>
      </div>
      {action}
    </div>
  );
});
